import React, { useState, useEffect } from 'react';
import DentistListMobile from './dentistListMobile';
import DentistListWeb from './dentistListWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};


const DentistListRouter = () => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768;

  return width < MOBILE_BREAKPOINT ? <DentistListMobile /> : <DentistListWeb />;
};

export default DentistListRouter;